// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-5989ef8b] .van-tab {
  display: none;
}
[data-v-5989ef8b] .van-tab--active {
  display: flex !important;
}
[data-v-5989ef8b] .van-tabs__line {
  display: none;
}
[data-v-5989ef8b] .van-button {
  background-color: #ff7a00;
}
[data-v-5989ef8b] .van-coupon-list__empty {
  display: flex !important;
  flex-direction: column;
  align-items: center;
}
[data-v-5989ef8b] .van-coupon__amount {
  font-size: 14px;
}
[data-v-5989ef8b] .van-coupon__amount span {
  font-size: 30px;
}

`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
